"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));

var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.image"));

var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

var _gerenciatdUnifiedicons = _interopRequireWildcard(require("@bit/gerenciatd.unifiedicons.svg-icon-loader"));

require("./index.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const HoverEffectCard = ({
  item,
  cardTheme,
  taggingInfo
}) => {
  const [width, setWidth] = (0, _react.useState)(window.innerWidth);
  const [hover, setHover] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  const mouseEnter = () => {
    setHover(true);
  };

  const mouseLeave = () => {
    setHover(false);
  };

  const textHidden = width < 1260;
  const textShow = !textHidden && hover ? item.subtitle : item.title;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `Hover-effect-card__${cardTheme}`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `Hover-effect-card__image-wrapper__${cardTheme}`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, {
        className: `Hover-effect-card__image__${cardTheme}`,
        src: item.src,
        alt: item.title,
        dynamicResiz: false
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `Hover-effect-card__text-container-bgc__${cardTheme}`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `Hover-effect-card__text-container__${cardTheme}`,
      onMouseEnter: mouseEnter,
      onMouseLeave: mouseLeave,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents3.default, {
        link: item.link,
        isBlockElement: true,
        taggingInfo: taggingInfo,
        className: `Hover-effect-card__link__${cardTheme}`,
        children: [cardTheme === 'large' && !hover && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedicons.default, {
          kind: _gerenciatdUnifiedicons.SVG_ICON_KIND.LIGHT,
          color: _gerenciatdUnifiedicons.COLOR.WHITE,
          segment: _gerenciatdUnifiedicons.SEGMENT.EMP,
          backgroundColor: _gerenciatdUnifiedicons.COLOR.TRANSPARENT,
          size: 72,
          id: item.icon,
          className: `Hover-effect-card__icon__${cardTheme}`
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, {
          className: `Hover-effect-card__title__${cardTheme}`,
          align: "center",
          kind: "heading",
          level: 3,
          size: "title04",
          color: "white",
          fontType: "font-bold",
          text: textShow,
          segment: "emp"
        })]
      })
    })]
  });
};

var _default = HoverEffectCard;
exports.default = _default;

//# sourceMappingURL=index.js.map